import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useStateWithMutators } from '@rad/hooks';
import { useToken, navigate, fetchMerchantSubscription } from '../../utility/general';
import { PLANS, SITE } from '../../utility/constants';
import OnboardingSteps from '../components/onboarding/onboarding-steps';
import SubscriptionPlans from '../components/subscription/subscription-plans';
import SubscriptionPlanConfirmation from '../components/subscription/subscription-plan-confirmation';
import SubscriptionProcessing from '../components/subscription/subscription-processing';
import SubscriptionPaymentSuccess from '../components/subscription/subscription-payment-success';
export default (_props) => {
    const token = useToken();
    const [state, mutators] = useStateWithMutators({
        'view': {
            'currentStep': 0,
            'industry': SITE,
            'plan': PLANS.Essentials,
            'hasSubscription': null,
            'currentPlan': null,
            'subscription': null,
            'createMSAApplication': false,
            'includeWebsite': false,
            'desiredDomain': '',
        },
    });
    React.useEffect(() => {
        if (!token)
            return;
        if (!token.merchant) {
            navigate('#/');
            return;
        }
        let cancelled = false;
        fetchMerchantSubscription(token.merchant.id, false).then((subscription) => {
            var _a, _b, _c, _d;
            if (cancelled)
                return;
            mutators.view.subscription(subscription);
            mutators.view.hasSubscription((_a = subscription.has_subscription) !== null && _a !== void 0 ? _a : false);
            // Prefer the scheduled plan when set; addon-only scheduled changes leave new_plan null,
            // so fall back to the currently-billed subscription_plan in that case.
            mutators.view.currentPlan((subscription.is_updating && subscription.new_plan)
                ? subscription.new_plan
                : subscription.subscription_plan);
            // Seed the addon toggle from the server: prefer pending (scheduled) value when set,
            // otherwise the currently-billed value. Keeps the picker in sync with server state.
            const effectiveIncludeWebsite = (_c = (_b = subscription.new_include_website) !== null && _b !== void 0 ? _b : subscription.include_website) !== null && _c !== void 0 ? _c : false;
            mutators.view.includeWebsite(effectiveIncludeWebsite);
            mutators.view.desiredDomain((_d = subscription.desired_domain) !== null && _d !== void 0 ? _d : '');
        });
        return () => {
            cancelled = true;
        };
    }, [token]);
    const handleNavigateToStep = (step) => {
        mutators.view.currentStep(step !== null && step !== void 0 ? step : state.view.currentStep + 1);
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "container mb-2 mt-3", children: _jsx(OnboardingSteps, { currentStep: state.view.currentStep + 4 }) }), _jsx("div", { className: "container", children: _jsxs("div", { className: "row justify-content-center", children: [state.view.currentStep === 0 && (_jsx(SubscriptionPlans, { view: state.view, onNavigateToStep: handleNavigateToStep, onSelectPlan: mutators.view.plan, onSetIncludeWebsite: mutators.view.includeWebsite, onSetDesiredDomain: mutators.view.desiredDomain })), state.view.currentStep === 1 && (_jsx(SubscriptionPlanConfirmation, { view: state.view, onNavigateToStep: handleNavigateToStep, onSetCreateMSAApplication: mutators.view.createMSAApplication })), state.view.currentStep === 2 && (_jsx(SubscriptionProcessing, { view: state.view, onNavigateToStep: handleNavigateToStep })), state.view.currentStep === 3 && _jsx(SubscriptionPaymentSuccess, { view: state.view })] }) })] }));
};
